// import { Avatar } from '@chakra-ui/react';
// import { useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { Popover } from 'react-tiny-popover';
// import styled, { keyframes } from 'styled-components';
// import { logoutUser } from '../../../redux/actions/authActions';
// import { arrowRight, logout } from './Icons';
// import { useDispatch } from 'react-redux';

// const ProfileMenu = ({ setBg, bgImg }) => {
//     const [open, setOpen] = useState(false);
//     let navigate = useNavigate();
//     const dispatch = useDispatch();

//     const handleLogout = () => {
//         logoutUser(dispatch);
//         navigate('/');
//     };
//     return (
//         <Popover
//             isOpen={open}
//             positions={['bottom']}
//             reposition={true}
//             align="start"
//             onClickOutside={() => setOpen(!open)}
//             content={
//                 <MenuContainer>
//                     <p
//                         style={{
//                             margin: '0 1rem .5rem',
//                             fontSize: '15px',
//                         }}>
//                         KYC Process 2/5
//                     </p>
//                     <p
//                         style={{
//                             margin: '0 1rem .5rem',
//                             backgroundColor: '#f6f6f9',
//                             fontSize: '13px',
//                             padding: '5px 25px',
//                         }}>
//                         Get Started
//                     </p>
//                     <div
//                         onClick={() => {
//                             //   setChosenValue(opt.name);
//                             //   setOption(opt.name);
//                             setOpen(!open);
//                             setBg(open);
//                         }}>
//                         <p>Training </p> <p>{arrowRight}</p>
//                     </div>
//                     <div
//                         onClick={() => {
//                             setOpen(!open);
//                         }}>
//                         <p> Notification</p> <p>{arrowRight}</p>
//                     </div>
//                     <div
//                         onClick={() => {
//                             setOpen(!open);
//                         }}>
//                         <Link to="/dashboard/settings">
//                             <p>Account Settings</p>{' '}
//                         </Link>{' '}
//                         <p>{arrowRight}</p>
//                     </div>
//                     <div
//                         onClick={() => {
//                             setOpen(!open);
//                             handleLogout();
//                         }}>
//                         <p>Log Out</p> <p>{logout}</p>
//                     </div>
//                 </MenuContainer>
//             }>
//             <Avatar
//                 name="Kent Dodds"
//                 src={bgImg || 'https://bit.ly/kent-c-dodds'}
//                 size="sm"
//                 mx={2}
//                 cursor="pointer"
//                 onClick={() => {
//                     setOpen(!open);
//                     setBg(open);
//                 }}
//             />
//         </Popover>
//     );
// };

// export default ProfileMenu;
// const DropDownSlide = keyframes`
//   100%
//   { -webkit-transform: translateY(0);
//       transform: translateY(0);
//   }
//   0% {
//       -webkit-transform: translateY(10px);
//       transform: translateY(10px);
//   }
//   `;
// const MenuContainer = styled.main`
//     min-width: 320px;
//     width: auto;
//     animation-name: ${DropDownSlide};
//     animation-duration: 0.3s;
//     min-height: 114px;
//     padding: 1.5rem 0.5rem;
//     margin-top: 1rem;
//     margin-right: 2rem;
//     background: #ffffff;
//     box-sizing: border-box;
//     box-shadow: 0 1rem 3rem rgb(0 0 0 / 18%);
//     font-size: 15px;
//     div {
//         display: flex;
//         justify-content: space-between;
//         align-items: center;
//         border-top: 1px solid #f6f6f9;
//         margin: 0.4rem auto;
//         padding: 0.5rem 1.5rem;

//         p {
//             /* padding: 0.5rem 0.5rem 0.5rem 1rem; */
//             font-style: normal;
//             font-weight: 400;
//             font-size: 15px;
//             line-height: 20px;
//         }
//         :hover {
//             background: #f6f6f9;
//         }
//     }

//     & > * {
//         cursor: pointer;
//     }
// `;

import { memo, useCallback, useMemo } from 'react';
import {
    Menu,
    MenuButton,
    MenuList,
    MenuDivider,
    Box,
    Flex,
    Text,
    Avatar as ChakraAvatar,
} from '@chakra-ui/react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logoutUser } from '../../../redux/actions/authActions';
import useGetUserDetails from 'hooks/useGetUserDetail';

/* ─────────────────────────────────────────────────────────────
   BRAND TOKENS — matches DashHead / MobileMenu / Navigation
   ───────────────────────────────────────────────────────────── */

const NAVY        = '#1B3B5F';
const CYAN        = '#DCF8F9';
const INK         = '#1A2740';
const MUTED       = '#5A6B7E';
const FAINT       = '#8896AE';
const SURFACE     = '#FFFFFF';
const SURFACE_ALT = '#F7F9FB';
const BORDER      = '#E8EDF5';
const DANGER      = '#E53E3E';

const FONT = "'Bricolage Grotesque', sans-serif";

const SHADOW_MD = '0 4px 16px rgba(27,59,95,0.08)';
const NAVY_ACTIVE_BG = 'rgba(27, 59, 95, 0.08)';

/* ─────────────────────────────────────────────────────────────
   WHATSAPP SUPPORT — same env contract as the dashboard RightPanel
   ───────────────────────────────────────────────────────────── */

const SUPPORT_WHATSAPP_NUMBER =
    (typeof process !== 'undefined' && process.env?.REACT_APP_SUPPORT_WHATSAPP) ||
    '2348000000000';

const openWhatsAppSupport = () => {
    const msg = 'Hi Obana team, I need help with my dashboard.';
    const url = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
};

/* ─────────────────────────────────────────────────────────────
   ICONS — inline SVG so we don't depend on icon barrel files
   ───────────────────────────────────────────────────────────── */

const UserIcon = (props) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...props}>
        <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.8" />
        <path d="M4 21c0-4 4-7 8-7s8 3 8 7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
);

const BuildingIcon = (props) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...props}>
        <rect x="4" y="3" width="16" height="18" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
        <path d="M9 8h2M13 8h2M9 12h2M13 12h2M9 16h2M13 16h2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
);

const CardIcon = (props) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...props}>
        <rect x="2.5" y="5" width="19" height="14" rx="2" stroke="currentColor" strokeWidth="1.8" />
        <path d="M2.5 10h19" stroke="currentColor" strokeWidth="1.8" />
        <path d="M6 15h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
);

const ChartIcon = (props) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M3 21h18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M7 17V11M12 17V7M17 17V13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
);

const ChatIcon = (props) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"
            stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    </svg>
);

const ExternalIcon = (props) => (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M14 4h6v6M20 4l-9 9M9 5H5a1 1 0 00-1 1v13a1 1 0 001 1h13a1 1 0 001-1v-4"
            stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const LogoutIcon = (props) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"
            stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

/* ─────────────────────────────────────────────────────────────
   MENU CONFIG — single source of truth.
   Internal links route via React Router; external opens via window.open.
   ───────────────────────────────────────────────────────────── */

const PROFILE_ITEMS = [
    { key: 'user',        label: 'My Account',             path: '/dashboard/profile/user',        icon: UserIcon },
    { key: 'partner',     label: 'Partner Info',           path: '/dashboard/profile/partner',     icon: BuildingIcon },
    { key: 'payment',     label: 'Payment Info',           path: '/dashboard/profile/paymentinfo', icon: CardIcon },
    { key: 'performance', label: 'Performance & Earnings', path: '/dashboard/profile/performance', icon: ChartIcon },
];

/* ─────────────────────────────────────────────────────────────
   SHARED MENU ITEM ROW
   ───────────────────────────────────────────────────────────── */

const MenuRow = memo(function MenuRow({
    icon: Icon, label, onClick, isExternal, danger, ...rest
}) {
    const color = danger ? DANGER : MUTED;

    return (
        <Flex
            as={onClick ? 'button' : undefined}
            type={onClick ? 'button' : undefined}
            onClick={onClick}
            role="menuitem"
            align="center"
            gap="10px"
            w="full"
            p="10px 14px"
            bg="transparent"
            color={color}
            fontSize="13px"
            fontWeight="500"
            fontFamily={FONT}
            textAlign="left"
            cursor="pointer"
            transition="background 0.15s ease, color 0.15s ease"
            _hover={{
                bg: danger ? '#FFF5F5' : NAVY_ACTIVE_BG,
                color: danger ? DANGER : NAVY,
            }}
            _active={{
                bg: danger ? '#FED7D7' : NAVY_ACTIVE_BG,
            }}
            _focusVisible={{
                outline: `2px solid ${danger ? DANGER : NAVY}`,
                outlineOffset: '-2px',
            }}
            {...rest}
        >
            <Box flexShrink={0} color="inherit">
                <Icon />
            </Box>
            <Text as="span" flex="1" minW="0" noOfLines={1} color={danger ? DANGER : INK}>
                {label}
            </Text>
            {isExternal && (
                <Box color={FAINT} flexShrink={0}>
                    <ExternalIcon />
                </Box>
            )}
        </Flex>
    );
});

/* ─────────────────────────────────────────────────────────────
   IDENTITY HEADER — name, email, agent id
   ───────────────────────────────────────────────────────────── */

const IdentityHeader = memo(function IdentityHeader({ name, email, agentId, avatarUrl, initial }) {
    return (
        <Flex
            align="center"
            gap="12px"
            p="14px 16px"
            bg={SURFACE_ALT}
            borderBottom="1px solid"
            borderColor={BORDER}
        >
            {avatarUrl ? (
                <ChakraAvatar
                    src={avatarUrl}
                    name={name}
                    size="md"
                    bg={CYAN}
                    color={NAVY}
                    flexShrink={0}
                />
            ) : (
                <Flex
                    w="40px"
                    h="40px"
                    borderRadius="full"
                    bg={CYAN}
                    color={NAVY}
                    align="center"
                    justify="center"
                    fontWeight="800"
                    fontSize="14px"
                    fontFamily={FONT}
                    flexShrink={0}
                >
                    {initial}
                </Flex>
            )}
            <Box flex="1" minW="0">
                <Text
                    fontSize="13px"
                    fontWeight="700"
                    color={INK}
                    fontFamily={FONT}
                    lineHeight="1.2"
                    noOfLines={1}
                >
                    {name}
                </Text>
                {email && (
                    <Text fontSize="11px" color={MUTED} mt="2px" lineHeight="1.2" noOfLines={1}>
                        {email}
                    </Text>
                )}
                {agentId && (
                    <Text fontSize="10px" color={FAINT} mt="2px" lineHeight="1.2" fontWeight="600">
                        Agent · {agentId}
                    </Text>
                )}
            </Box>
        </Flex>
    );
});

/* ─────────────────────────────────────────────────────────────
   MAIN
   ───────────────────────────────────────────────────────────── */

const ProfileMenu = ({ bgImg }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    /* Single source of user details */
    const { flattenedUser } = useGetUserDetails();
    const details = flattenedUser?.attributes;

    /* Derived display values, defensive against missing fields */
    const displayName = useMemo(() => {
        const first = details?.first_name;
        const last  = details?.last_name;
        if (first || last) return [first, last].filter(Boolean).join(' ');
        return flattenedUser?.email?.split('@')[0] || 'User';
    }, [details?.first_name, details?.last_name, flattenedUser?.email]);

    const displayEmail = useMemo(
        () => flattenedUser?.email || details?.email || '',
        [flattenedUser?.email, details?.email]
    );

    const agentId = flattenedUser?.agent_id || details?.agent_id || null;

    const avatarUrl = bgImg || details?.user_image || details?.user_imgage || null;

    const initial = useMemo(
        () => (displayName?.charAt(0) || 'U').toUpperCase(),
        [displayName]
    );

    /* Logout handler */
    const handleLogout = useCallback(() => {
        logoutUser(dispatch);
        navigate('/');
    }, [dispatch, navigate]);

    return (
        <Menu placement="bottom-end" autoSelect={false} closeOnSelect>
            <MenuButton
                as={Box}
                cursor="pointer"
                aria-label="Open profile menu"
                role="button"
                tabIndex={0}
                borderRadius="full"
                transition="box-shadow 0.15s ease, transform 0.15s ease"
                _hover={{ transform: 'translateY(-1px)' }}
                _focusVisible={{
                    boxShadow: `0 0 0 3px ${CYAN}`,
                    outline: 'none',
                }}
            >
                {avatarUrl ? (
                    <ChakraAvatar
                        src={avatarUrl}
                        name={displayName}
                        size="sm"
                        bg={CYAN}
                        color={NAVY}
                    />
                ) : (
                    <Flex
                        w="32px"
                        h="32px"
                        borderRadius="full"
                        bg={CYAN}
                        color={NAVY}
                        align="center"
                        justify="center"
                        fontWeight="800"
                        fontSize="13px"
                        fontFamily={FONT}
                    >
                        {initial}
                    </Flex>
                )}
            </MenuButton>

            <MenuList
                p="0"
                minW="280px"
                maxW="320px"
                borderRadius="14px"
                border="1px solid"
                borderColor={BORDER}
                boxShadow={SHADOW_MD}
                overflow="hidden"
                fontFamily={FONT}
                bg={SURFACE}
            >
                {/* IDENTITY HEADER */}
                <IdentityHeader
                    name={displayName}
                    email={displayEmail}
                    agentId={agentId}
                    avatarUrl={avatarUrl}
                    initial={initial}
                />

                {/* PROFILE NAVIGATION */}
                <Box py="6px">
                    {PROFILE_ITEMS.map((item) => (
                        <MenuRow
                            key={item.key}
                            as={Link}
                            to={item.path}
                            icon={item.icon}
                            label={item.label}
                        />
                    ))}
                </Box>

                <MenuDivider m="0" borderColor={BORDER} />

                {/* SUPPORT */}
                <Box py="6px">
                    <MenuRow
                        icon={ChatIcon}
                        label="Help & Support"
                        isExternal
                        onClick={openWhatsAppSupport}
                    />
                </Box>

                <MenuDivider m="0" borderColor={BORDER} />

                {/* LOGOUT — destructive, separated */}
                <Box py="6px">
                    <MenuRow
                        icon={LogoutIcon}
                        label="Log out"
                        onClick={handleLogout}
                        danger
                    />
                </Box>
            </MenuList>
        </Menu>
    );
};

export default ProfileMenu;